import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import { CDN_BASE_URL } from "../../config";
import ProductCardDesc from "../../components/common/card/ProductCardDesc";
import { FaAngleRight, FaTimes } from "react-icons/fa";
import Loading from "../../components/common/Loading";
import Modal from "@mui/material/Modal";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import { Helmet } from "react-helmet";
import { DealerDataContext } from "../../context/DealerDataContext";
import { toEnglishDigits } from "../../components/common/mobile/ProductsMobile";
import { useRouteInfo } from "../../hooks/useRouteInfo";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  backgroundColor: "#fff",
  boxShadow: 24,
  padding: 15,
  borderRadius: 10,
  height: "80vh",
  overflowY: "scroll",
};

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  boxShadow: 24,
  borderRadius: 10,
  minWidth: 300,
};

const ComapreMobilePage = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedBrand, setselectedBrand] = useState();
  const [vehicles, setvehicles] = useState([]);
  const [data, setdata] = useState({ t1: "", t2: "", t3: "" });
  const [vehiclesSearched, setvehiclesSearched] = useState();
  const [show, setShow] = useState();
  const [index, setindex] = useState();
  const [text, settext] = useState();
  const [show2, setShow2] = useState(false);
  const [search_type, setsearch_type] = useState(false);
  const { dealerData } = useContext(DealerDataContext);
  const { metaData } = useRouteInfo();

  const [brand, setBrand] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/brand", {}, {}).then(({ data }) => {
      setBrand(data?.data);
    });
    setLoading(false);
  }

  useEffect(() => {
    if (selectedBrand) {
      getDataVehicle();
    }
  }, [selectedBrand]);

  async function getDataVehicle() {
    setLoading(true);
    await httpReauest(
      "GET",
      "/vehicle?brand=" + selectedBrand?._id,
      {},
      {}
    ).then(({ data }) => {
      setvehicles(data?.data);
    });
    setLoading(false);
  }

  useEffect(() => {
    if (text && text !== "") {
      const timeout = setTimeout(() => {
        handleChange();
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [text]);

  async function handleChange() {
    setLoading(true);

    const value = text;

    if (search_type === "product_number") {
      await httpReauest(
        "GET",
        `/url/vehicle/search?search_key=${value}${
          search_type ? "&search_type=" + search_type : ""
        }`,
        {},
        {}
      ).then(({ data }) => {
        setvehiclesSearched(data?.data);
      });
    } else {
      await httpReauest(
        "GET",
        `/url/vehicle/search?search_key=${value}`,
        {},
        {}
      ).then(({ data }) => {
        setvehiclesSearched(data?.data);
      });
    }

    setLoading(false);
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      {show2 && (
        <Modal
          open={show2}
          onClose={() => setShow2(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div dir="rtl" className="outline-none" style={style2}>
            <div className="p-4 flex flex-col gap-2">
              <h3 className="font-bold mb-2 flex justify-between items-center">
                نوع جستجو{" "}
                <FaTimes
                  color="#000"
                  onClick={() => setShow2(false)}
                  className="cursor-pointer"
                  size={16}
                />
              </h3>
              <span className="flex justify-between">
                <span className="text-[#2E3132] text-[16px] font-[500]">
                  اسم محصول
                </span>
                <label class="inline-flex items-center cursor-pointer relative">
                  <input
                    type="radio"
                    name="product"
                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                    id="product"
                    checked={search_type === "product"}
                    onClick={(e) => setsearch_type("product")}
                  />
                  <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                    </svg>
                  </span>
                </label>
              </span>
              <span className="flex justify-between">
                <span className="text-[#2E3132] text-[16px] font-[500]">
                  شماره محصول
                </span>
                <label class="inline-flex items-center cursor-pointer relative">
                  <input
                    type="radio"
                    name="product_number"
                    id="product_number"
                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-40"
                    checked={search_type === "product_number"}
                    onClick={(e) => setsearch_type("product_number")}
                  />
                  <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                    </svg>
                  </span>
                </label>
              </span>
            </div>
          </div>
        </Modal>
      )}
      {show && <RequestTalkModal setShow={setShow} />}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div dir="rtl" style={style}>
          <h2 className="text-[14px] font-[600] text-center pt-3">
            لطفا برند کامیون مورد نظر را انتخاب کنید یا نام کامیون را جستجو کنید
          </h2>
          <div className="my-8 flex justify-center">
            {" "}
            <span className="relative  w-full">
              <input
                className="w-full form-brand-mobile  h-[48px]"
                placeholder="جستجو"
                onChange={(e) => settext(toEnglishDigits(e.target.value))}
              />
              <img
                src="/Filter.png"
                alt="filter"
                onClick={() => setShow2(true)}
                className="absolute translate-y-[-50%] top-[50%] left-4"
              />
            </span>
          </div>
          {loading ? (
            <Loading />
          ) : vehiclesSearched ? (
            <div className="grid grid-cols-1 gap-3 pt-3">
              <span className="">
                <button
                  className="flex items-center mb-3 mr-5 text-[16px]"
                  onClick={() => {
                    setselectedBrand(null);
                    setvehiclesSearched(null);
                  }}
                >
                  <FaAngleRight size={20} /> بازگشت به برند ها
                </button>
              </span>
              {vehiclesSearched?.map((e) => (
                <ProductCardDesc
                  handleClose={handleClose}
                  setdata={setdata}
                  setselectedBrand={setselectedBrand}
                  select
                  index={index}
                  data={e}
                />
              ))}
            </div>
          ) : selectedBrand ? (
            <div className="grid grid-cols-1 gap-3 pt-3">
              <span className="">
                <button
                  className="flex items-center mb-3 mr-5 text-[16px]"
                  onClick={() => setselectedBrand(null)}
                >
                  <FaAngleRight size={20} /> بازگشت به برند ها
                </button>
                <div className="flex gap-2 items-center">
                  <img
                    src={CDN_BASE_URL + selectedBrand?.logo}
                    alt={selectedBrand?.name}
                    className="w-[100px]"
                  />
                  <h3 className="text-secendory font-[600] text-[16px]">
                    محصولات برند {selectedBrand?.name}
                  </h3>
                </div>
              </span>
              {vehicles?.map((e) => (
                <ProductCardDesc
                  handleClose={handleClose}
                  setdata={setdata}
                  setselectedBrand={setselectedBrand}
                  select
                  index={index}
                  data={e}
                />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-3 pt-3">
              {brand?.map((e) => (
                <span
                  onClick={() => setselectedBrand(e)}
                  className="border border-dashed rounded-[10px] p-2  h-[100px] cursor-pointer"
                >
                  <img
                    src={CDN_BASE_URL + e.logo}
                    className="w-full h-full object-contain"
                    alt={e.name}
                  />
                </span>
              ))}
            </div>
          )}
        </div>
      </Modal>{" "}
      <Link to={"/"} className="flex gap-2 items-center text-[14px]">
        <img src="/Arrow - Left 2.png" alt="" className="w-[24px]" />
        بازگشت به صفحه خانه
      </Link>
      <div className="py-4">
        <h1 className="title-mobile text-center ">{metaData?.h1}</h1>
        <div className="grid grid-cols-4 mt-7">
          <span>
            <h3 className="text-[18px] font-bold py-3"> مشخصات</h3>
            <div className="py-3 border-t border-dashed flex flex-col px-4 font-bold">
              <span className="relative py-3 balck-circle-small">
                قدرت موتور
              </span>
              <span className="relative py-3 balck-circle-small">
                حجم موتور
              </span>
              <span className="relative py-3 balck-circle-small">
                حداکثر گشتاور
              </span>
              <span className="relative py-3 balck-circle-small">
                استاندارد آلایندگی
              </span>
              <span className="relative py-3 balck-circle-small">
                مدل گیربکس
              </span>
              <span className="relative py-3 balck-circle-small">
                تعداد دنده
              </span>
              <span className="relative py-3 balck-circle-small">
                سیستم ترمز
              </span>
              <span className="relative py-3 balck-circle-small">
                ظرفیت مخزن سوخت
              </span>
              <span className="relative py-3 balck-circle-small">تعلیق</span>
              <span className="relative py-3 balck-circle-small">
                امکانات اضافی
              </span>
              <span className="relative py-3 balck-circle-small">
                مشکلات احتمالی
              </span>
            </div>
          </span>
          <span className="col-span-3 grid grid-cols-3">
            {data.t1 !== "" ? (
              <span className="flex flex-col justify-between">
                <div className="border-r border-dashed">
                  <h3 className="text-[14px] py-[15px] text-center">
                    {" "}
                    {data.t1.name}
                  </h3>
                  <div className="py-3 border-t flex flex-col px-2 justify-between border-dashed">
                    <span className="relative py-3 text-center">
                      {data.t1.url?.engine_power
                        ? data.t1.url?.engine_power
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.engine_size
                        ? data.t1.url?.engine_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.max_torque
                        ? data.t1.url?.max_torque
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.excellence
                        ? data.t1.url?.excellence
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.gearbox ? data.t1.url?.gearbox : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.gear_number
                        ? data.t1.url?.gear_number
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.breake_system
                        ? data.t1.url?.breake_system
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.fuel_size
                        ? data.t1.url?.fuel_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.suspension
                        ? data.t1.url?.suspension
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.other_feature
                        ? data.t1.url?.other_feature
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t1.url?.problems ? data.t1.url?.problems : "_____"}
                    </span>
                    <Link
                      to={`/${data.t1.url.category.url}/${data.t1.url.brand.name}/${data.t1.url.name}`}
                      className="border-brand-2 p-2 mt-4 text-center"
                    >
                      مشاهده
                    </Link>
                    <button
                      onClick={() => {
                        setdata((cur) => ({ ...cur, t1: "" }));
                      }}
                      className="bg-black text-white flex mt-2 items-center justify-center h-[36px] rounded-[8px]  text-center"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </span>
            ) : (
              <span className="border-r border-dashed">
                <div className="pb-3 px-3 border-b pt-[3px] border-dashed">
                  <button
                    onClick={() => {
                      handleOpen();
                      setindex("t1");
                    }}
                    className="border-brand-2 p-2 w-full"
                  >
                    انتخاب
                  </button>
                </div>
              </span>
            )}

            {data.t2 !== "" ? (
              <span className="flex flex-col justify-between">
                <div className="border-r border-dashed">
                  <h3 className="text-[14px] py-[15px] text-center">
                    {" "}
                    {data.t2.name}
                  </h3>
                  <div className="py-3 border-t flex flex-col px-2 justify-between border-dashed">
                    <span className="relative py-3 text-center">
                      {data.t2.url?.engine_power
                        ? data.t2.url?.engine_power
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.engine_size
                        ? data.t2.url?.engine_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.max_torque
                        ? data.t2.url?.max_torque
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.excellence
                        ? data.t2.url?.excellence
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.gearbox ? data.t2.url?.gearbox : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.gear_number
                        ? data.t2.url?.gear_number
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.breake_system
                        ? data.t2.url?.breake_system
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.fuel_size
                        ? data.t2.url?.fuel_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.suspension
                        ? data.t2.url?.suspension
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.other_feature
                        ? data.t2.url?.other_feature
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t2.url?.problems ? data.t2.url?.problems : "_____"}
                    </span>
                    <Link
                      to={`/${data.t2?.url?.category?.url}/${data.t2?.url?.brand?.name}/${data.t2?.url?.name}`}
                      className="border-brand-2 p-2 mt-4 text-center"
                    >
                      مشاهده
                    </Link>
                    <button
                      onClick={() => {
                        setdata((cur) => ({ ...cur, t2: "" }));
                      }}
                      className="bg-black text-white flex mt-2 items-center justify-center h-[36px] rounded-[8px]  text-center"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </span>
            ) : (
              <span className="border-r border-dashed">
                <div className="pb-3 px-3 border-b pt-[3px] border-dashed">
                  <button
                    onClick={() => {
                      handleOpen();
                      setindex("t2");
                    }}
                    className="border-brand-2 p-2 w-full"
                  >
                    انتخاب
                  </button>
                </div>
              </span>
            )}
            {data.t3 !== "" ? (
              <span className="flex flex-col justify-between">
                <div className="border-r border-dashed">
                  <h3 className="text-[14px] py-[15px] text-center">
                    {" "}
                    {data.t3.name}
                  </h3>
                  <div className="py-3 border-t flex flex-col px-2 justify-between border-dashed">
                    <span className="relative py-3 text-center">
                      {data.t3.url?.engine_power
                        ? data.t3.url?.engine_power
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.engine_size
                        ? data.t3.url?.engine_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.max_torque
                        ? data.t3.url?.max_torque
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.excellence
                        ? data.t3.url?.excellence
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.gearbox ? data.t3.url?.gearbox : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.gear_number
                        ? data.t3.url?.gear_number
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.breake_system
                        ? data.t3.url?.breake_system
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.fuel_size
                        ? data.t3.url?.fuel_size
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.suspension
                        ? data.t3.url?.suspension
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.other_feature
                        ? data.t3.url?.other_feature
                        : "_____"}
                    </span>
                    <span className="relative py-3 text-center">
                      {data.t3.url?.problems ? data.t3.url?.problems : "_____"}
                    </span>
                    <Link
                      to={`/${data.t3?.url?.category?.url}/${data.t3?.url?.brand?.name}/${data.t3?.url?.name}`}
                      className="border-brand-2 p-2 mt-4 text-center"
                    >
                      مشاهده
                    </Link>
                    <button
                      onClick={() => {
                        setdata((cur) => ({ ...cur, t3: "" }));
                      }}
                      className="bg-black text-white flex mt-2 items-center justify-center h-[36px] rounded-[8px]  text-center"
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </span>
            ) : (
              <span className="border-r border-dashed">
                <div className="pb-3 px-3 border-b pt-[3px] border-dashed">
                  <button
                    onClick={() => {
                      handleOpen();
                      setindex("t3");
                    }}
                    className="border-brand-2 p-2 w-full"
                  >
                    انتخاب
                  </button>
                </div>
              </span>
            )}
          </span>
        </div>
        <div className="mt-10">
          {" "}
          <Link
            to={`tel:${dealerData?.phone}`}
            className="btn-brand-mobile  w-full block text-center my-2"
          >
            {dealerData?.phone}
          </Link>
          <button
            onClick={() => setShow(true)}
            className="border-brand-2 p-3 w-full block text-center mt-3 mb-7"
          >
            درخواست مشاوره تلفنی
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComapreMobilePage;
